module.exports = __webpack_public_path__ + "static/media/gryphon-atelier-gold.02881853.svg";